var React = require('react');

function IconClose (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M88.2,93.9L56.7,62.4l31.4-31.4c1.2-1.1,1.2-3,0-4.2l-2.5-2.5c-1.1-1.2-3-1.2-4.2,0L50,55.7L18.6,24.2c-1.1-1.2-3-1.2-4.2,0  l-2.5,2.5c-1.2,1.1-1.2,3,0,4.2l31.5,31.5L11.8,94.1c-1.2,1.1-1.2,3,0,4.2l2.5,2.5c1.1,1.2,3,1.2,4.2,0L50,69.2l31.5,31.5 c1.1,1.2,3,1.2,4.2,0l2.5-2.5C89.4,97,89.4,95.1,88.2,93.9z"}));
}

IconClose.defaultProps = {"version":"1.1","x":"0px","y":"0px","xmlSpace":"preserve","fill":"#fff","width":"30","height":"30","viewBox":"10 20 82 125","preserveAspectRatio":"xMinYMin slice"};

module.exports = IconClose;

IconClose.default = IconClose;
